import type { SearchParams } from "~www/types/search-params";

import { buildTeamMemberBioHref } from "./build-team-member-bio-href";

function resolveTeamMemberBioHref({
  basePath,
  memberId,
  pathname,
  searchParams,
}: {
  basePath?: string;
  memberId: string;
  pathname: string;
  searchParams?: SearchParams;
}): string {
  const href = buildTeamMemberBioHref({
    basePath: basePath ?? pathname,
    memberId,
    searchParams,
  });

  return href.startsWith("?") ? `${pathname}${href}` : href;
}

export { resolveTeamMemberBioHref };
